export enum RoleEnum {
    ADMIN = 'ADMIN',
    USER = 'USER',
    AFFILIATE_ADMIN = 'AFFILIATE_ADMIN',
    AFFILIATE_VIEWER = 'AFFILIATE_VIEWER',
    TTE_DEPOT_OPERATOR = 'TTE_DEPOT_OPERATOR',
    STOCK_ACCOUNTANT = 'STOCK_ACCOUNTANT',
    REVALIDATOR = 'REVALIDATOR',
    MANUFACTURER = 'MANUFACTURER',
    POINT_OF_SALE_REP = 'POINT_OF_SALE_REP',
    SITE_ADMIN = 'SITE_ADMIN',
    SITE_SUPERVISOR = 'SITE_SUPERVISOR',
}
